<div class="drop-down-btn" [ngClass]="{'focus': showDropContainer, 'disabled': loading}" (click)="toggleMenu()" dstClickOutside
     [clickOutsideEnabled]="showDropContainer" (clickOutside)="showDropContainer = false;">
  <span>Selected {{ buttonLabel }}</span>
  <div class="flt-right">
    @if (selected.size) {
<div class="badge a-bg-primary">{{selected.size}}</div>
}
    @if (loading) {
<span class="loader-container" aria-hidden="true">
      <i class="fa fa-spinner fa-spin"></i>
    </span>
}
    <span class="Appkit4-icon chevron icon-down-chevron-outline" [class.open]="showDropContainer"></span>
  </div>
  @if (showDropContainer) {
<div class="gt-drop-container"
       [style.top.px]="dropdownTop" [style.left.px]="dropdownLeft"
       (click)="$event.stopPropagation();">
    <div class="left-menu">
      <div class="toolbar">
        <span (click)="selectAll()" style="float: left; text-decoration: underline; cursor: pointer; ">Select All</span>
        <span (click)="unselectAll()" style="float: right; text-decoration: underline; cursor: pointer; ">Unselect All</span>
      </div>
      <ul class="parent-me-list">
        @for (item of data; track $index) {
<li (click)="expandParentME(item)" [ngClass]="{'selected' : item.active}">
          <ap-checkbox [(ngModel)]="item.selected" (onChange)="onParentMeSelected(item)" (click)="$event.stopPropagation();"></ap-checkbox>
          <span class="list-desc">{{item.name}}</span>
          @if (item.numSelected! > 0) {
<div class="badge a-bg-primary">{{item.numSelected}}</div>
}
        </li>
}
      </ul>
    </div>
    @if (showRightMenu) {
<div class="right-container">
      @for (meNode of selectedParentMe.children; track $index) {
<gtw-df-me-dropdown-node [node]="meNode"
                               (nodeSelectionChanged)="onChildrenSelectionChanged($event)"></gtw-df-me-dropdown-node>
}
    </div>
}
  </div>
}
</div>
